import { Link } from "react-router-dom";
import { Sparkles, Clock } from "lucide-react";
import { useProfile } from "@/context/ProfileContext";

export const ChoosePlan = () => {
  const { profile, logout } = useProfile();
  const kid = profile.access?.payer === "parent";
  return (
    <div className="max-w-2xl mx-auto px-6 py-20 text-center" data-testid="paywall">
      <div className="mx-auto w-16 h-16 rounded-full grid place-items-center bg-[#FBF3E2] text-[#C87D53]"><Sparkles className="w-8 h-8" /></div>
      <h1 className="font-display text-4xl sm:text-5xl text-[#2C4A3E] mt-6">{kid ? "Time to ask your grown-up" : "Your free trial has ended"}</h1>
      <p className="mt-4 text-stone-600">{kid ? "Your family's free trial is over. Ask your parent to choose a plan so you and your Buddy can keep learning." : "We hope you loved learning mindfully. Choose a plan to keep your lessons, Buddy, progress and records going."}</p>
      {!kid && <Link to="/pricing" data-testid="paywall-choose-plan" className="mt-8 inline-block px-8 py-4 rounded-full bg-[#C87D53] text-white text-lg">Choose a plan</Link>}
      <div className="mt-6"><button onClick={logout} data-testid="paywall-logout" className="text-sm text-stone-500 underline">Sign out</button></div>
    </div>
  );
};

export const TrialBanner = () => {
  const { profile } = useProfile();
  const a = profile?.access;
  if (a?.reason !== "trial" || a.payer) return null;
  const days = Math.max(0, Math.ceil((new Date(a.trial_ends) - Date.now()) / 86400000));
  const soon = days <= 3;
  return (
    <div className={`border-b text-sm px-6 py-2 flex flex-wrap justify-center items-center gap-3 ${soon ? "bg-[#C87D53] border-[#B36C44] text-white" : "bg-[#FBF3E2] border-[#F2D49B] text-[#7A4A12]"}`} data-testid="trial-banner">
      <Clock className="w-4 h-4" /> <span data-testid="trial-days">{days <= 1 ? "Last day of your free trial" : `${days} days left in your free trial`}</span>
      {soon ? <Link to="/pricing" data-testid="trial-see-plans" className="px-4 py-1 rounded-full bg-white text-[#C87D53] font-medium">Choose a plan</Link>
        : <Link to="/pricing" data-testid="trial-see-plans" className="font-medium underline">See plans</Link>}
    </div>
  );
};
